module.exports = __webpack_public_path__ + "img/domijn_logov1.98002d43.png";